import { Box, Link, Stack, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import InfoSection from "@quest_editor/components/InfoSection";

const CheckInstructionSection = ({
  checkerNote,
  setCheckerNote,
  receiptCheckDescription,
  setReceiptCheckDescription,
  adminSetting,
  codeAdminUrl,
}: {
  checkerNote: string;
  setCheckerNote: (v: string) => void;
  receiptCheckDescription: string;
  setReceiptCheckDescription: (v: string) => void;
  adminSetting: { alreadySet: boolean; fileName: string };
  codeAdminUrl: string;
}) => {
  const { t } = useTranslation("questEditor");

  return (
    <InfoSection
      title={t("quest_edit.check_instruction.title")}
      rows={[
        {
          label: t(
            "quest_edit.check_instruction.form.explanation_for_checker.label",
          ),
          children: (
            <TextField
              size="small"
              multiline
              rows={4}
              placeholder={t(
                "quest_edit.check_instruction.form.explanation_for_checker.placeholder",
              )}
              fullWidth
              value={checkerNote}
              onChange={(e) => setCheckerNote(e.target.value)}
            ></TextField>
          ),
        },
        {
          label: t(
            "quest_edit.check_instruction.form.explanation_receipt_check.label",
          ),
          children: (
            <TextField
              size="small"
              multiline
              rows={4}
              placeholder={t(
                "quest_edit.check_instruction.form.explanation_receipt_check.placeholder",
              )}
              fullWidth
              value={receiptCheckDescription}
              onChange={(e) => setReceiptCheckDescription(e.target.value)}
            ></TextField>
          ),
        },
        {
          label: t("quest_edit.check_instruction.form.phone_num.label"),
          children: (
            <Stack direction="column" spacing={1}>
              <Box sx={{ color: "text.secondary" }}>
                {t("quest_edit.check_instruction.form.phone_num.note")}
                <Link
                  href={codeAdminUrl}
                  color="primary"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t("quest_edit.check_instruction.form.phone_num.sub_note")}
                </Link>
                {t("quest_edit.check_instruction.form.phone_num.new_tab")}
              </Box>
              {adminSetting.alreadySet ? (
                <Box sx={{ color: "text.secondary" }}>
                  {adminSetting.fileName}
                </Box>
              ) : (
                <Box sx={{ color: "text.secondary", mt: 1 }}>
                  {t("quest_edit.check_instruction.form.file.nodata")}
                </Box>
              )}
            </Stack>
          ),
        },
      ]}
    />
  );
};

export default CheckInstructionSection;
